<template>
    <section>
        <mex-buscar-sucursal :data="data" @update:filteredOfficesRegion="updateFilteredOffices" />
        <mex-sucursal-respuesta :filteredOffices="filteredOffices" />
        <div class="column is-full my-5 pb-0">
            <scroll-to-top-button />
        </div>
    </section>
</template>

<script>
import MexBuscarSucursal from './MexBuscarSucursal.vue';
import MexSucursalRespuesta from './MexSucursalRespuesta.vue';
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    components: {
        MexBuscarSucursal,
        MexSucursalRespuesta
    },
    data() {
        return {
            filteredOffices: []
        }
    },
    methods: {
        updateFilteredOffices(offices) {
            this.filteredOffices = offices;
        }
    }
}
</script>
